/**
 * 组件信息
 */
export const info = {
  name: 'xy-list-item-layout', // 组件名   xy-scroll-list
  type: 'component-container', // 组件类型
  label: '列表子项', // 组件label
  icon: 'icon-xy-list-item-layout', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: {},
      // 事件
      events: []
    })
  },
  language: {
    type: String,
    default: 'en'
  },
  list: {
    type: [String, Array],
    default: ''
  },
  hiddenIndexs: {
    type: String,
    default: ''
  },
  direction: {
    type: String,
    default: 'vertical'
  },
  listIndex: {
    type: Object,
    default: null
  },
  listItemData: {
    type: [Object, Array, String, Number, Boolean],
    default: undefined
  }
}

/**
 * 组件开放方法事件
 */
export const events = [
  {
    name: 'clearSelect', // 事件名
    label: '清空选中数据' // 事件描述
  },
  {
    name: 'scrollToIndex',
    label: '滚动到指定下标',
    params: [{ label: '下标', value: 'index' }]
  }
]

/**
 * 组件开放数据源
 */
export const dataSource = [
  {
    label: '列表下标',
    keys: 'index'
  },
  {
    label: '当前选中下标',
    keys: 'selectIndex'
  },
  {
    label: '当前选中数据',
    keys: 'selectData'
  }
]

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input', // 表单组件
    label: '列表数据源', // 表单名称
    propKey: 'list', // 表单model字段名称
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-input', // 表单组件
    label: '隐藏下标', // 表单名称
    propKey: 'hiddenIndexs' // 表单model字段名称
  },
  {
    type: 'xy-form-select', // 表单组件
    label: '列表方向', // 表单名称
    propKey: 'direction', // 表单model字段名称
    options: [
      {
        label: '垂直',
        value: 'vertical'
      },
      {
        label: '水平',
        value: 'horizontal'
      },
      {
        label: '网格',
        value: 'grid'
      }
    ] // 选项
  }
]
